export var AVLPageContainerActionTypes;
(function (AVLPageContainerActionTypes) {
    AVLPageContainerActionTypes["INIT"] = "avl.page.INIT";
    AVLPageContainerActionTypes["SET_CONNECTION_INFO"] = "avl.page.SET_CONNECTION_INFO";
})(AVLPageContainerActionTypes || (AVLPageContainerActionTypes = {}));
